<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
    <el-row>
      <el-col :span="12">
        <el-form-item label="物资名称" prop="goods_name">
          <el-input v-model="addEditForm.goods_name" placeholder="请输入物资名称"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="物资类型" prop="goods_tag">
          <el-select v-fixZoom v-model="addEditForm.goods_tag" placeholder="请选择" style="width: 230px;color: white">
            <el-option v-for="item in goodstags" :key="item.id"
                       :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="编号" prop="">
          <el-input v-model="addEditForm.goods_code" placeholder="请输入编号"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="价格" prop="goods_price">
          <el-input v-model="addEditForm.goods_price" placeholder="请输价格"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="数量" prop="goods_count">
          <el-input type="number" v-model="addEditForm.goods_count" placeholder="请输入数量"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="规格" prop="goods_specifications">
          <el-input v-model="addEditForm.goods_specifications" placeholder="请输入规格"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="批次" prop="goods_batch_number">
          <el-input v-model="addEditForm.goods_batch_number" placeholder="请输入批次"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="位置" prop="goods_location">
          <el-input v-model="addEditForm.goods_location" placeholder="请输入位置"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
<!--        <el-form-item label="有效期至" prop="goods_valid">-->
<!--          <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.goods_valid"-->
<!--                          type="date" value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx">-->
<!--          </el-date-picker>-->
<!--        </el-form-item>-->
      </el-col>
    </el-row>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEdit('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {creategoodsentity, updategoodsentity} from '../../../api/yanglaoyuan'

export default {
  name: 'addEditGoods',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      goodstags: [{id: 1, name: '固定资产'}, {id: 2, name: '生活物资'}],
      addEditForm: {
        'id': 0,
        'e_id': 0,
        'goods_tag': '',
        'goods_name': '',
        'goods_code': '',
        'goods_count': '',
        'goods_price': '',
        'goods_location': '',
        'goods_batch_number': '',
        'goods_specifications': '',
        'goods_valid': '',
        'goods_extra_info': '{}'
      },
      addEditRules: {
        goods_tag: [
          {required: true, message: '请选择', trigger: 'change'}
        ],
        goods_name: [
          {required: true, message: '请输入物资名称', trigger: 'blur'}
        ],
        goods_price: [
          {required: true, message: '请输入价格', trigger: 'blur'}
        ],
        goods_count: [
          {required: true, message: '请输入数量', trigger: 'blur'}
        ],
        goods_valid: [
          {required: true, message: '请选择', trigger: 'change'}
        ]
      }
    }
  },
  created () {
    if (this.addEditObj.isAdd) {
      this.addEditForm.e_id = this.$store.state.user.LoginResp.entity_id
    } else {
      this.addEditForm.id = this.addEditObj.row.id
      this.addEditForm.e_id = this.addEditObj.row.e_id
      this.addEditForm.goods_tag = this.addEditObj.row.goods_tag
      this.addEditForm.goods_name = this.addEditObj.row.goods_name
      this.addEditForm.goods_code = this.addEditObj.row.goods_code
      this.addEditForm.goods_count = this.addEditObj.row.goods_count
      this.addEditForm.goods_price = this.addEditObj.row.goods_price
      this.addEditForm.goods_location = this.addEditObj.row.goods_location
      this.addEditForm.goods_batch_number = this.addEditObj.row.goods_batch_number
      this.addEditForm.goods_specifications = this.addEditObj.row.goods_specifications
      this.addEditForm.goods_valid = this.addEditObj.row.goods_valid
    }
  },
  methods: {
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            'id': this.addEditForm.id,
            'e_id': this.addEditForm.e_id,
            'goods_tag': this.addEditForm.goods_tag,
            'goods_name': this.addEditForm.goods_name,
            'goods_code': this.addEditForm.goods_code,
            'goods_count': parseInt(this.addEditForm.goods_count),
            'goods_price': this.addEditForm.goods_price,
            'goods_location': this.addEditForm.goods_location,
            'goods_batch_number': this.addEditForm.goods_batch_number,
            'goods_specifications': this.addEditForm.goods_specifications,
            'goods_valid': this.addEditForm.goods_valid,
            'goods_extra_info': this.addEditForm.goods_extra_info
          }
          if (this.addEditObj.isAdd) {
            creategoodsentity(data).then(res => {
              this.$notify({title: '成功', message: '成功新增', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else {
            updategoodsentity(data).then(res => {
              this.$notify({title: '成功', message: '成功编辑', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditGoods.vue